import {
  getAction,
  deleteAction,
  putAction,
  postAction,
  uploadFildForPost,
  deleteActionForData
} from '@/api/manage'

import {
  axios
} from '@/utils/request'
////根路径
// const doMian = "/jeecg-boot/";
////图片预览请求地址
// const imgView = "http://localhost:8080/jeecg-boot/sys/common/view/";

//角色管理
const addRole = (params) => postAction("/sys/role/add", params);
const editRole = (params) => putAction("/sys/role/edit", params);
const editInspectionRole = (params) => putAction("/inspection/role/editRoleConfig", params);
// const getRoleList = (params)=>getAction("/sys/role/list",params);
// const deleteRole = (params)=>deleteAction("/sys/role/delete",params);
// const deleteRoleList = (params)=>deleteAction("/sys/role/deleteBatch",params);
const checkRoleCode = (params) => getAction("/sys/role/checkRoleCode", params);
const queryall = (params) => getAction("/sys/role/queryall", params);

//用户管理
const addUser = (params) => postAction("/sys/user/add", params);
const editUser = (params) => putAction("/sys/user/edit", params);
const queryUserRole = (params) => getAction("/sys/user/queryUserRole", params);
const getUserList = (params) => getAction("/sys/user/list", params);
// const deleteUser = (params)=>deleteAction("/sys/user/delete",params);
// const deleteUserList = (params)=>deleteAction("/sys/user/deleteBatch",params);
const frozenBatch = (params) => putAction("/sys/user/frozenBatch", params);
//验证用户是否存在
const checkOnlyUser = (params) => getAction("/sys/user/checkOnlyUser", params);
//改变密码
const changePassword = (params) => putAction("/sys/user/changePassword", params);

//权限管理
const addPermission = (params) => postAction("/sys/permission/add", params);
const editPermission = (params) => putAction("/sys/permission/edit", params);
const getPermissionList = (params) => getAction("/sys/permission/list", params);
/*update_begin author:wuxianquan date:20190908 for:添加查询一级菜单和子菜单查询api */
const getSystemMenuList = (params) => getAction("/sys/permission/getSystemMenuList", params);
const getSystemSubmenu = (params) => getAction("/sys/permission/getSystemSubmenu", params);
const getSystemSubmenuBatch = (params) => getAction('/sys/permission/getSystemSubmenuBatch', params)
/*update_end author:wuxianquan date:20190908 for:添加查询一级菜单和子菜单查询api */

// const deletePermission = (params)=>deleteAction("/sys/permission/delete",params);
// const deletePermissionList = (params)=>deleteAction("/sys/permission/deleteBatch",params);
const queryTreeList = (params) => getAction("/sys/permission/queryTreeList", params);
const queryTreeListForRole = (params) => getAction("/sys/role/queryTreeList", params);
const queryListAsync = (params) => getAction("/sys/permission/queryListAsync", params);
const queryRolePermission = (params) => getAction("/sys/permission/queryRolePermission", params);
const saveRolePermission = (params) => postAction("/sys/permission/saveRolePermission", params);
//const queryPermissionsByUser = (params)=>getAction("/sys/permission/queryByUser",params);
const queryPermissionsByUser = (params) => getAction("/sys/permission/getUserPermissionByToken", params);
const loadAllRoleIds = (params) => getAction("/sys/permission/loadAllRoleIds", params);
const getPermissionRuleList = (params) => getAction("/sys/permission/getPermRuleListByPermId", params);
const queryPermissionRule = (params) => getAction("/sys/permission/queryPermissionRule", params);

// 部门管理
const queryDepartTreeList = (params) => getAction("/sys/sysDepart/queryTreeList", params);
const queryIdTree = (params) => getAction("/sys/sysDepart/queryIdTree", params);
const queryParentName = (params) => getAction("/sys/sysDepart/queryParentName", params);
const searchByKeywords = (params) => getAction("/sys/sysDepart/searchBy", params);
const deleteByDepartId = (params) => deleteAction("/sys/sysDepart/delete", params);

//二级部门管理
const queryDepartPermission = (params) => getAction("/sys/permission/queryDepartPermission", params);
const saveDepartPermission = (params) => postAction("/sys/permission/saveDepartPermission", params);
const queryTreeListForDeptRole = (params) => getAction("/sys/sysDepartPermission/queryTreeListForDeptRole", params);
const queryDeptRolePermission = (params) => getAction("/sys/sysDepartPermission/queryDeptRolePermission", params);
const saveDeptRolePermission = (params) => postAction("/sys/sysDepartPermission/saveDeptRolePermission", params);
const queryMyDepartTreeList = (params) => getAction("/sys/sysDepart/queryMyDeptTreeList", params);

//日志管理
//const getLogList = (params)=>getAction("/sys/log/list",params);
const deleteLog = (params) => deleteAction("/sys/log/delete", params);
const deleteLogList = (params) => deleteAction("/sys/log/deleteBatch", params);

//数据字典
const addDict = (params) => postAction("/sys/dict/add", params);
const editDict = (params) => putAction("/sys/dict/edit", params);
//const getDictList = (params)=>getAction("/sys/dict/list",params);
const treeList = (params) => getAction("/sys/dict/treeList", params);
// const delDict = (params)=>deleteAction("/sys/dict/delete",params);
//const getDictItemList = (params)=>getAction("/sys/dictItem/list",params);
const addDictItem = (params) => postAction("/sys/dictItem/add", params);
const editDictItem = (params) => putAction("/sys/dictItem/edit", params);
//const delDictItem = (params)=>deleteAction("/sys/dictItem/delete",params);
//const delDictItemList = (params)=>deleteAction("/sys/dictItem/deleteBatch",params);
export const Tospareclass = (code, params) => getAction(`${code}`, params);
//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/sys/dict/getDictItems/${code}`, params);
//获取报备代理商的品类
export const ajaxcategory = (code, params) => getAction(`/sys/user/productType/${code}`, params);
//获取可以报备的品类
export const Baobeipinlei = (params) => getAction(`/gcgl/gcglClueinfo/type/`, params);
//系统通告
const doReleaseData = (params) => getAction("/sys/annountCement/doReleaseData", params);
const doReovkeData = (params) => getAction("/sys/annountCement/doReovkeData", params);
//获取系统访问量
const getLoginfo = (params) => getAction("/sys/loginfo", params);
const getVisitInfo = (params) => getAction("/sys/visitInfo", params);
//获取访客系统访问量
const getAnalysisData = (params) => postAction("/visitor/base/analysis/getAnalysisData", params);
const getAnalysisSourceData = (params) => postAction("/visitor/base/analysis/getAnalysisSourceData", params);
const getRealTimeAnalysisData = (params) => getAction("/visitor/base/analysis/getRealTimeAnalysisData", params);
const getSourcePieData = (params) => postAction("/visitor/base/analysis/getSourcePieData", params);
const getVisitorPlacePieData = (params) => postAction("/visitor/base/analysis/getVisitorPlacePieData", params);
//数据日志访问
// const getDataLogList = (params)=>getAction("/sys/dataLog/list",params);

//项目联想 *华*
export const geTassociate = (params) => getAction("/gcgl/gcglDeveloper/developerList", params);
// 根据部门主键查询用户信息
const queryUserByDepId = (params) => getAction("/sys/user/queryUserByDepId", params);

// 查询用户角色表里的所有信息
const queryUserRoleMap = (params) => getAction("/sys/user/queryUserRoleMap", params);
// 重复校验
const duplicateCheck = (params) => getAction("/sys/duplicate/check", params);
// 加载分类字典
const loadCategoryData = (params) => getAction("/sys/category/loadAllData", params);
const checkRuleByCode = (params) => getAction('/sys/checkRule/checkByCode', params)

//获取短信发送记录
const getSmsRecord = (params) => postAction("/goldenHomeMsgMange/getsmssendlog", params);
//获取短信模板
const getMessageInfo = (parms) => postAction("/goldenHomeMsgMange/getmessageinfo", parms);
//添加短信模板
const addMessageTemple = (parms) => postAction("/goldenHomeMsgMange/addmessage", parms);
//更新模板
const upadteMessageTemlate = (parms) => postAction("/goldenHomeMsgMange/updatemessage", parms);
//获取所有信息账号
const getAllIndustry = (parms) => postAction("/goldenHomeMsgMange/getAllIndustry", parms);
//新获取所有信息账号
const getNewAllIndustry = (parms) => getAction("/base/busCommonMessageAccountNew/list", parms);
//添加信息账号
const addIndustry = (parms) => postAction("/goldenHomeMsgMange/addIndustry", parms);
//修改信息账号
const updateIndustry = (parms) => postAction("/goldenHomeMsgMange/updateIndustry", parms);
//删除信息账号
const delIndustry = (parms) => postAction("/goldenHomeMsgMange/delIndustry", parms);
//获取短信类型选项
const getMessageType = (parms) => postAction("/goldenHomeMsgMange/getMessageTypeSelection", parms);
//段落拆成句子
const getMssageContentView = (parms) => postAction("/goldenHomeMsgMange/getMssageContentView", parms);
//获取所有来选
const getAllSources = (parms) => postAction("/goldenHomeMsgMange/getAllSources", parms);
//删除来源
const delSources = (parms) => postAction("/goldenHomeMsgMange/delSources", parms);
//修改来源信息
const updateSources = (parms) => postAction("/goldenHomeMsgMange/updateSources", parms);
//新增来源
const addSerouces = (parms) => postAction("/goldenHomeMsgMange/addSerouces", parms);
//获得来源选择器
const getSourcesSelecetOpion = (parms) => postAction("/goldenHomeMsgMange/getSourcesSelecetOpion", parms);
//获得平台顺序选择器
const getPlatformSchemeSelecetOpion = (parms) => getAction("/message/platform/scheme/listAll", parms);
//新短信平台通过短信分类查appnan
const getListBySmsType = (parms) => getAction("/base/busCommonMessageAccountCm/listBySmsType", parms);


//物料图片管理
const queryMaterialTreeList = (params) => getAction("/erp/materialManagement/queryTreeList", params);
const queryMaterialImageList = (params) => getAction('/erp/materialManagement/queryMaterialImageList', params)
const queryUploadOrNotUploadMaterialImageList = (params) => getAction('/erp/materialManagement/queryUploadOrNotUploadMaterialImageList', params)
//上传图片
const uploadMaterialFile = (params, config) => uploadFildForPost('/erp/materialManagement/uploadMaterialFile', params, config)
//更新物料的图片路径
const updateMaterialImageData = (parms) => postAction("/erp/materialManagement/updateData", parms);

//获取来源下所有用户
const getSourceAllUser = (parms) => postAction("/goldenHomeMsgMange/getSourceAllUser", parms);
//查找用户
const searchUser = (parms) => postAction("/goldenHomeMsgMange/searchUser", parms);
//删除来源下用户
const delSourceUser = (parms) => postAction("/goldenHomeMsgMange/delSourceUser", parms);
//添加用户到来源
const addSourceUser = (parms) => postAction("/goldenHomeMsgMange/addSourceUser", parms);

//品牌荣誉  数据字典关联查询
const queryDetailCategoryListByCategory = (params) => getAction("/base/busGisBrandPower/queryDetailCategoryListByCategory", params);
//品牌荣誉图片上传
const uploadBrandFile = (params, config) => uploadFildForPost('/sys/common/upload?fileType=huayun', params, config)
//金牌石图片编辑的图片上传
const uploadStoneFile = (params, config) => uploadFildForPost('/goldenstone.base/goldStoneJpglist/upload', params, config)

//获取首页数据
//获取模板发送量Top 5
const templateTop5Count = (params) => axios({
  url: "/base/homePage/templateTop5Count",
  method: 'post',
  data: params,
  timeout: 35000
});
//获取消息源发送量Top 5
const newsSourceTop5Count = (params) => axios({
  url: "/base/homePage/newsSourceTop5Count",
  method: 'post',
  data: params,
  timeout: 35000
})
//获取短信成功失败总量
const everyCount = (params) => postAction("/base/homePage/everyCount", params);
//获取每天短信成功失败数量
const allCount = (params) => postAction("/base/homePage/allCount", params);
//获取所有账号使用数量
const getCountThisMouthSendType = () => postAction("/goldenHomeMsgMange/getCountThisMouthSendType");
//统计短信类型本月内使用情况
const getCountThisMouthMessageType = () => postAction("/goldenHomeMsgMange/getCountThisMouthMessageType");
//获取所有模板使用情况
const getCountTemplateUseTimes = () => postAction("/goldenHomeMsgMange/getCountTemplateUseTimes");
//获取随机生成的密码
const createPassword = () => getAction("/goldenHomeMsgMange/createPassword")
//获取选择器选项
const getTemplateCodeSelectOption = () => getAction("/goldenHomeMsgMange/getTemplateCodeSelectOption")
//更新用户可用模板号
const updateUserCanUseTemplate = (params) => postAction("/goldenHomeMsgMange/updateUserCanUseTemplate", params)
//获得用户有权限的模板
const getUserCanReadTemplate = (parms) => postAction("/goldenHomeMsgMange/getUserCanReadTemplate", parms)
//获取计费列表信息
const getMessageBillingTablateDate = (parms) => postAction("/goldenHomeMsgMange/getMessageBillingTablateDate", parms)
//获取车间接口
const findDepartList = (params) => postAction("/inspection/api/findDepartList", params);
//用户车间中间表-添加
const addBusInspectionUserWorkshop = (params) => postAction("/busInspectionUserWorkshop/add", params);
//统计人员的达成率（横向条形图)
const countAchievementRate = (params) => postAction("/busInspectionReport/countAchievementRatePC", params);
//统计车间巡查改善完成率（横向条形图）
const countImproveRatePC = (params) => postAction("/busInspectionReport/countImproveRatePC", params)
//统计车间巡查异常率（横向条形图）
const countQuestionRate = (params) => postAction("/busInspectionReport/countQuestionRatePC", params)
//根据用户编号查找是否是管理员及所属基地
const findRoleAndBase = (params) => postAction("/inspection/api/report/findRoleAndBase/" + params)
//根据角色编码基地查找角色接口
const findInspectionRole = (params) => postAction("/inspection/api/findInspectionRole/" + params)
//按用户编码查找部门
const findDepartByUserNo = (params) => postAction("/inspection/api/findDepartByUserNo", params)
//获取膜皮手册
const membraneGenerateQRCode = (params) => postAction("/membrane/generateQRCode", params)
//获取样块手册
const sampleBlockGenerateQRCode = (params) => postAction("/sampleBlock/generateQRCode", params)
//金牌石获取次数
const goldStoneJpglistsVisitLogGetCount = (params) => getAction("/goldenstone.base/goldStoneJpglistsVisitLog/getCount", params)
//桔家石获取次数
const goldStoneOrangeStoneJpglistsVisitLogGetCount = (params) => getAction("/jujiastone/goldStoneJpglistsVisitLog/getCount", params)
//工厂日历
const getFactoryCalendarList = (params) => postAction("/busInspectionFactoryCalendar/getFactoryCalendarList", params)
const saveOrUpdateFactoryCalendarList = (params) => postAction("/busInspectionFactoryCalendar/saveOrUpdate", params)
//通过车间编码获取部门ID和部门名称
const queryDepartByBaseNo = (params) => getAction("/workshop/busInspectionBaseDepart/queryByBaseNo", params)

const checkBusInspectionBaseDepart = (params) => getAction("/workshop/busInspectionBaseDepart/check", params)
const checkBusInspectionDepartWorkshop = (params) => getAction("/workshop/busInspectionDepartWorkshop/check", params)
//巡检分组车间配置表-根据分组id查找车间
const findGroupWorkshopByGroupId = (params) => getAction("/groupworkshop/busInspectionGroupWorkshop/findByGroupId", params)
//获取华为云最新数据
const gethHuaYunProjectBatch = (params) => axios({
  url: "/common/huaYunProject/batchAdd",
  method: 'get',
  params,
  timeout: 90000
})
//获取处理人字典
const hwyHandlerDict = (params) => getAction("/org/jeecg/busWeeklySummary/handlerDict")
//获取项目名称字典
const hwyProjectNameDict = (params) => getAction("/org/jeecg/busWeeklySummary/projectNameDict")
// 炸单
const execERPGHomeOrderDataByBom = (data) => axios({
  url: "/factory/base/ghomeDischargeUtils/execERPGHomeOrderDataByBom",
  method: 'post',
  data,
  timeout: 6000000
})
//建议与反馈行政人员权限启用与禁用
const feedbackManagerFbUserDelflag = (params) => deleteActionForData("/administration.base/feedbackManager/fbUserDelflag", params)
// 微信启动后
const updateWeComNotices = (params) => postAction("/administration.base/feedbackManager/updateWeComNotices", params)

//反馈受理接口
const feedbackAcceptance = (params) => getAction("/administration/base/feedbackContent/feedbackAcceptance", params)
//反馈受理接口
const feedbackProcessingCompleted = (data) => postAction("/administration/base/feedbackContent/feedbackProcessingCompleted", data)
//短信计费获取新短信平台账号
const getAccountNameListDict = (data) => getAction("/base/busCommonMessageAccountCm/getAccountNameList", data)
//访客系统 取消访问
const cancelVistors = (data) => postAction("/visitor/base/visitor/cancelVistors", data)
//访客模板下载
const getVisitorDictList = (data) => postAction("visitor/base/open/openApi/getVisitorDictList", data)


//行政巡查通用版开发
//工厂日历
const getFactoryCalendarListOfGeneral = (params) => postAction("/general/busInspectionFactoryCalendar/getFactoryCalendarList", params)
const saveOrUpdateFactoryCalendarListOfGeneral = (params) => postAction("/general/busInspectionFactoryCalendar/saveOrUpdate", params)
//通过车间编码获取部门ID和部门名称
const queryDepartByBaseNoOfGeneral = (params) => getAction("/general/workshop/busInspectionBaseDepart/queryByBaseNo", params)
const checkBusInspectionBaseDepartOfGeneral = (params) => getAction("/general/workshop/busInspectionBaseDepart/check", params)
const checkBusInspectionDepartWorkshopOfGeneral = (params) => getAction("/general/workshop/busInspectionDepartWorkshop/check", params)
//巡检分组车间配置表-根据分组id查找车间
const findGroupWorkshopByGroupIdOfGeneral = (params) => getAction("/general/groupworkshop/busInspectionGroupWorkshop/findByGroupId", params)
//获取车间接口
const findDepartListOfGeneral = (params) => postAction("/general/inspection/api/findDepartList", params);
//用户车间中间表-添加
const addBusInspectionUserWorkshopOfGeneral = (params) => postAction("/general/busInspectionUserWorkshop/add", params);
//统计人员的达成率（横向条形图)
const countAchievementRateOfGeneral = (params) => postAction("/general/busInspectionReport/countAchievementRatePC", params);
//统计车间巡查改善完成率（横向条形图）
const countImproveRatePCOfGeneral = (params) => postAction("/general/busInspectionReport/countImproveRatePC", params)
//统计车间巡查异常率（横向条形图）
const countQuestionRateOfGeneral = (params) => postAction("/general/busInspectionReport/countQuestionRatePC", params)
//根据用户编号查找是否是管理员及所属基地
const findRoleAndBaseOfGeneral = (params) => postAction("/general/inspection/api/report/findRoleAndBase/" + params)
//根据角色编码基地查找角色接口
const findInspectionRoleOfGeneral = (params) => postAction("/general/inspection/api/findInspectionRole/" + params)
//按用户编码查找部门
const findDepartByUserNoOfGeneral = (params) => postAction("/general/inspection/api/findDepartByUserNo", params)


const editInspectionRoleOfGeneral = (params) => putAction("/general/inspection/role/editRoleConfig", params);
//通过username查找部门
const findByDepartByUsername = (params) => getAction("/visitor/base/open/openApi/findByDepart", params);
//
const visitorUpload = (params) => postAction("/visitor/base/open/openApi/uploadFile", params, {
  headers: {
    "Content-Type": "multipart/form-data;",
    "Accept": "*/*"
  }
});

const getVisitorConfigList = (params) => getAction("/visitor/base/open/openApi/getVisitorConfigList", params);
const getFindRoleByUserNo = (params) => getAction("/visitor/base/visitor/findRoleByUserNo", params);
const getVisitorDetailById = (params) => getAction("/visitor/base/visitor/queryById", params);
const getVisitorConfigById = (params) => getAction("/visitor/busVisitorConfig/queryById", params);
//门岗核销访客
const getVisitorListSY = (params) => getAction("/visitor/base/visitorWithSiYang/list", params);
const getUserAuthority = (params) => getAction("/visitor/base/visitorWithSiYang/getUserAuthority", params);

//工艺文件管理，获取树形分类
const getCommonFileManageClassList = (params) => getAction("/factory/base/commonFileManage/classList", params);
const deleteCommonFileManage = (params) => getAction("/factory/base/commonFileManage/classDelete", params);
const addCommonFileManage = (params) => postAction("/factory/base/commonFileManage/classAdd", params);
const editCommonFileManageClassList = (params) => postAction("/factory/base/commonFileManage/classEdit", params);

const selectCompanyByUserCode = (params) => getAction("/erp/showroomlogistics/logisticsInformation/selectCompanyByUserCode", params);


const selectCompanyInfoByUserCode = (params) => getAction("/erp/showroomlogistics/logisticsInformation/selectCompanyInfoByUserCode", params);

const selectCompanyInfoTree = (params) => getAction("/erp/showroomlogistics/logisticsInformation/selectCompanyInfoTree", params);
const selectShowroomInfoByCompanyId = (params) => getAction("/erp/showroomlogistics/logisticsInformation/selectShowroomInfoByCompanyId", params);

const getSyAccountTypeList = (params) => getAction("/goldenHomeMsgMange/getSyAccountTypeList", params);

const busInspectionBaseList = (params) => getAction("/general/workshop/busInspectionBase/list", params);

const sortCommonFileManage = (params) => postAction("/factory/base/commonFileManage/sort", params);

//日报设置预警
const setWarnWeeklySummary = (params) => getAction("/org/jeecg/busWeeklySummary/setWarn", params);

// 获取日报管理系统的相关配置项
const getDailyConfigList = (params) => getAction("/dailyproject/busDailyConfig/list", {
  pageNo: 1,
  pageSize: 10,
  configFilter: params
});

const reviseProjectMember = (params) => postAction("/dailyproject/busDailyProjectUser/reviseProjectMember", params);

const batchAddDailyProjectUserNext = (params) => postAction("/dailyproject/busDailyProjectUserNext/batchAdd", params);

const deleteProjectUserNextByProjectId = (params) => deleteAction("/dailyproject/busDailyProjectUserNext/deleteByProjectId", params);

const addBusDailyProjectUser = () => postAction("/dailyproject/busDailyProjectUserNext/addBusDailyProjectUser");

const editDailyProject = (params) => postAction("/dailyproject/busDailyProject/edit", params);


//通过服务器ID查询服务器下面全部服务
const getBusServermanageServiceList = (params) => getAction("/servermanage/busServermanageService/list", params);
// 通过appid查询
const getServiceListByAppId = (params) => getAction("/servermanage/busServermanageService/listByAppId", params);

const getAppListByServiceId = (params) => getAction("/servermanage/busServermanageApp/listByServiceId", params);

// 通过serviceId批量插入
const addAppByServiceId = (params) => postAction("/servermanage/busServermanageAppService/addAppByServiceId", params);
// 通过deleteAppByServiceAppId
const deleteByServiceAppId = (params) => postAction("/servermanage/busServermanageAppService/deleteByServiceAppId", params)


const selectListByParamsNoPage = (params) => getAction("/crmapi/sys/jeeArea/selectListByParamsNoPage", params);

// 服务器管理 接口
const getAppListByServerId = (params) => getAction("/servermanage/busServermanageApp/listByServerId", params);
const getServerListByAppId = (params) => getAction("/servermanage/busServermanageServers/listByAppId", params);
const addServerByAppId = (params) => postAction("/servermanage/busServermanageAppServer/addServerByAppId", params);
const deleteByServerAppId = (params) => postAction("/servermanage/busServermanageAppServer/deleteByServerAppId", params);
// 服务器连通性检查
const testConnServer = (params) => getAction("/servermanage/busServermanageServers/testServer", params);
// 取应用和服务器关系表数据
const getAppServerRelation = (params) => getAction("/servermanage/busServermanageAppServer/getByAppIdAndServerId", params);

export {
  // imgView,
  // doMian,
  addRole,
  editRole,
  checkRoleCode,
  addUser,
  editUser,
  queryUserRole,
  getUserList,
  queryall,
  frozenBatch,
  checkOnlyUser,
  changePassword,
  getPermissionList,
  addPermission,
  editPermission,
  queryTreeList,
  queryListAsync,
  queryRolePermission,
  saveRolePermission,
  queryPermissionsByUser,
  loadAllRoleIds,
  getPermissionRuleList,
  queryPermissionRule,
  queryDepartTreeList,
  queryIdTree,
  queryParentName,
  searchByKeywords,
  deleteByDepartId,
  deleteLog,
  deleteLogList,
  addDict,
  editDict,
  treeList,
  addDictItem,
  editDictItem,
  doReleaseData,
  doReovkeData,
  getLoginfo,
  getVisitInfo,
  getAnalysisData,
  getAnalysisSourceData,
  getRealTimeAnalysisData,
  getSourcePieData,
  getVisitorPlacePieData,
  queryUserByDepId,
  queryUserRoleMap,
  duplicateCheck,
  queryTreeListForRole,
  getSystemMenuList,
  getSystemSubmenu,
  getSystemSubmenuBatch,
  loadCategoryData,
  checkRuleByCode,
  queryDepartPermission,
  saveDepartPermission,
  queryTreeListForDeptRole,
  queryDeptRolePermission,
  saveDeptRolePermission,
  queryMyDepartTreeList,
  getSmsRecord,
  getMessageInfo,
  addMessageTemple,
  upadteMessageTemlate,
  getAllIndustry,
  getNewAllIndustry,
  addIndustry,
  updateIndustry,
  delIndustry,
  getMessageType,
  queryMaterialTreeList,
  queryMaterialImageList,
  queryUploadOrNotUploadMaterialImageList,
  getMssageContentView,
  uploadMaterialFile,
  updateMaterialImageData,
  getAllSources,
  delSources,
  updateSources,
  addSerouces,
  getSourcesSelecetOpion,
  getPlatformSchemeSelecetOpion,
  getSourceAllUser,
  searchUser,
  delSourceUser,
  addSourceUser,
  queryDetailCategoryListByCategory,
  uploadBrandFile,
  uploadStoneFile,
  templateTop5Count,
  newsSourceTop5Count,
  everyCount,
  allCount,
  getCountThisMouthSendType,
  getCountTemplateUseTimes,
  getCountThisMouthMessageType,
  createPassword,
  getTemplateCodeSelectOption,
  updateUserCanUseTemplate,
  getUserCanReadTemplate,
  getMessageBillingTablateDate,
  findDepartList,
  addBusInspectionUserWorkshop,
  editInspectionRole,
  countAchievementRate,
  countQuestionRate,
  findRoleAndBase,
  countImproveRatePC,
  findDepartByUserNo,
  findInspectionRole,
  membraneGenerateQRCode,
  goldStoneJpglistsVisitLogGetCount,
  getFactoryCalendarList,
  saveOrUpdateFactoryCalendarList,
  checkBusInspectionBaseDepart,
  checkBusInspectionDepartWorkshop,
  queryDepartByBaseNo,
  findGroupWorkshopByGroupId,
  gethHuaYunProjectBatch,
  hwyHandlerDict,
  hwyProjectNameDict,
  execERPGHomeOrderDataByBom,
  feedbackManagerFbUserDelflag,
  feedbackAcceptance,
  feedbackProcessingCompleted,
  getListBySmsType,
  getAccountNameListDict,
  cancelVistors,
  getVisitorDictList,
  getFactoryCalendarListOfGeneral,
  saveOrUpdateFactoryCalendarListOfGeneral,
  queryDepartByBaseNoOfGeneral,
  checkBusInspectionBaseDepartOfGeneral,
  checkBusInspectionDepartWorkshopOfGeneral,
  findGroupWorkshopByGroupIdOfGeneral,
  findDepartListOfGeneral,
  addBusInspectionUserWorkshopOfGeneral,
  countAchievementRateOfGeneral,
  countImproveRatePCOfGeneral,
  countQuestionRateOfGeneral,
  findRoleAndBaseOfGeneral,
  findInspectionRoleOfGeneral,
  findDepartByUserNoOfGeneral,
  editInspectionRoleOfGeneral,
  findByDepartByUsername,
  visitorUpload,
  getVisitorConfigList,
  getFindRoleByUserNo,
  getUserAuthority,
  getVisitorListSY,
  getCommonFileManageClassList,
  deleteCommonFileManage,
  addCommonFileManage,
  editCommonFileManageClassList,
  getVisitorDetailById,
  getVisitorConfigById,
  selectCompanyByUserCode,
  selectCompanyInfoTree,
  selectShowroomInfoByCompanyId,
  getSyAccountTypeList,
  busInspectionBaseList,
  sampleBlockGenerateQRCode,
  sortCommonFileManage,
  selectCompanyInfoByUserCode,
  updateWeComNotices,
  setWarnWeeklySummary,
  getDailyConfigList,
  reviseProjectMember,
  batchAddDailyProjectUserNext,
  deleteProjectUserNextByProjectId,
  addBusDailyProjectUser,
  editDailyProject,
  getBusServermanageServiceList,
  getServiceListByAppId,
  addAppByServiceId,
  deleteByServiceAppId,
  getAppListByServiceId,
  selectListByParamsNoPage,
  getServerListByAppId,
  addServerByAppId,
  deleteByServerAppId,
  getAppListByServerId,
  testConnServer,
  getAppServerRelation
}